const pendingPhotoUploads = new Set<() => Promise<void>>();

export function registerPendingPhotoUploads(flush: () => Promise<void>): () => void {
  pendingPhotoUploads.add(flush);
  return () => {
    pendingPhotoUploads.delete(flush);
  };
}

export async function flushPendingPhotoUploads(): Promise<boolean> {
  const flushers = [...pendingPhotoUploads];
  await Promise.all(flushers.map((flush) => flush()));
  return flushers.length > 0;
}
